import React, { Dispatch } from "react";
import RLCloudSandboxToolbar from "../RLCloudSandboxToolbar";
import Time from "../../../../../components/Time";
import Typography from "../../../../../components/typography/Typography";
import { HistoryAnalysis } from "../../../../samples_cloud/@types";

type DropDownProps = {
  dropDownItem: HistoryAnalysis;
};

type AnalysisDropDownProps = {
  historyAnalysis: HistoryAnalysis[];
  activeAnalysisId: string;
  setActiveAnalysisId: Dispatch<string>;
};

const DropDownLabel: React.FC<DropDownProps> = ({ dropDownItem }) => (
  <>
    <Time time={dropDownItem.analysis_time} />
    <span>{` - ${dropDownItem.platform}`}</span>
  </>
);

const generateHistoryDropdownItems = (historyItems: HistoryAnalysis[]) =>
  historyItems.map(e => ({
    label: <DropDownLabel dropDownItem={e} />,
    value: e.analysis_id
  }));

const RlCloudSandboxAnalysisDropdown: React.FC<AnalysisDropDownProps> = ({
  historyAnalysis,
  activeAnalysisId,
  setActiveAnalysisId
}) => (
  <div className="rl-cloud-sandbox__screenshots-toolbar">
    <Typography variant="h4" tag="span">
      Analysis:
    </Typography>
    <RLCloudSandboxToolbar
      historyAnalysis={historyAnalysis}
      title={<DropDownLabel dropDownItem={historyAnalysis[0]} />}
      historyAnalysisMapper={generateHistoryDropdownItems}
      activeFilter={activeAnalysisId}
      handleHistoryDropdownChange={x => {
        setActiveAnalysisId(x);
      }}
      isStoredReport={false}
      style={{ backgroundColor: "white" }}
    />
  </div>
);

export default RlCloudSandboxAnalysisDropdown;
